import { useEffect } from 'react';
import { loadConfig } from './config';
import { persistLang, type Lang } from './i18n';
import { LangProvider, useLang } from './lang';
import { useReveal } from './motion';
import { Demo } from './pages/Demo';
import { Home } from './pages/Home';
import { Legal } from './pages/Legal';
import { Vision } from './pages/Vision';
import { Waste } from './pages/Waste';
import type { Route } from './routes';
import { Seo } from './seo';
import { Footer } from './sections/Footer';
import { Header } from './sections/Header';

const PAGES = {
  home: Home,
  waste: Waste,
  vision: Vision,
  demo: Demo,
  privacy: () => <Legal kind="privacy" />,
  terms: () => <Legal kind="terms" />,
} as const;

function Page({ route, lang }: { route: Route; lang: Lang }) {
  const { t } = useLang();
  useReveal(lang);
  const Body = PAGES[route];
  return (
    <>
      <Seo route={route} />
      <a className="skip" href="#content">
        {t('skip')}
      </a>
      <Header route={route} />
      <main id="content" tabIndex={-1} className={`page page-${route}`}>
        <Body />
      </main>
      <Footer route={route} />
    </>
  );
}

export function App({ route, lang }: { route: Route; lang: Lang }) {
  useEffect(() => {
    void loadConfig();
  }, []);

  useEffect(() => {
    persistLang(lang);
  }, [lang]);

  return (
    <LangProvider lang={lang}>
      <Page route={route} lang={lang} />
    </LangProvider>
  );
}
